export default "__VITE_ASSET__Dy7zd8sF__"